import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import { colors, padding, transition } from '../styles'
import styled from 'styled-components'

import SVG  from 'react-inlinesvg';
import facebook from "../../static/images/facebook.svg";
import twitter from "../../static/images/twitter.svg";
import linkedin from "../../static/images/linkedin.svg";

const icons = {
    facebook,
    twitter,
    linkedin
}

const SocialMedia = (props) =>  <StaticQuery
    query={graphql`
        query SocialsQuery {
            allMarkdownRemark(
                filter: {
                    frontmatter: { type: { eq: "page-options" } }
                }
            ){
                edges{
                    node{
                        frontmatter {
                            social_media {
                                facebook
                                twitter
                                linkedin
                            }
                        }
                    }
                }
            }
        }
    `}
    render={data => {

        const socials = data.allMarkdownRemark.edges[0].node.frontmatter.social_media

        return (
            <ul className={props.className}>
                {Object.keys(socials).map( (social, index) => {
                    return (
                        socials[social] !== '' ?
                            <li key={index}>
                                <a href={socials[social]} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    <SVG src={icons[social]} />
                                </a>
                            </li>
                        : null
                    )
                })}
            </ul>
        )
    }} 
/>

const StyledSocialMedia = styled(SocialMedia)`
    display: flex;
    justify-content: center;
    padding: 0;
    margin: 0 0 ${padding} 0;

    li {
        display: block;
        
        background: transparent;
        margin-right: calc(.5 * ${padding});

        &:last-child {
            margin-right: 0;
        }

        a {
            display: block;
            border: .25rem solid ${colors.blue};
            border-radius: 50%;
            height: calc(1.25 * ${padding});
            width: calc(1.25 * ${padding});
            transition: ${transition};

            svg {
                display: block;
                fill: ${colors.blue};
                transition: ${transition};
            }

            &:hover {
                border-color: ${colors.orange};

                svg {
                    fill: ${colors.orange};
                }
            }

        }
    }
`

export default StyledSocialMedia;